module.exports = __webpack_public_path__ + "img/arctic-circle-logo.056ab01f.svg";